import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesGenerateSelectionRoutingModule } from './pages-generate-selection-routing.module';
import { PageGenerateSelectionComponent } from './page-generate-selection/page-generate-selection.component';
import { GenerateSelectionModule } from '../../components/generate-selection/generate-selection.module';


@NgModule({
  declarations: [
    PageGenerateSelectionComponent
  ],
  imports: [
    CommonModule,
    PagesGenerateSelectionRoutingModule,
    GenerateSelectionModule
  ]
})
export class PagesGenerateSelectionModule { }
